<div [vnDynamicHtml]="item.text"></div>
